




























































import Mp3Player from '@/components/.global/Mp3Player.vue';
import { mapGetters } from '~/vuex';
import { ActorsApi } from '@/api';
import { ActorPortfolioModel } from '@model';
import { mapActions } from 'vuex';

export default {
    name: 'MyVoice',

    components: {
        Mp3Player,
    },

    props: {
        value: {
            required: true,
        },

        name: {
            required: true,
        },

        hlasId: {
            required: true,
        },
    },

    data: () => ({
        states: {
            idle: 'idle',
            saving: 'saving',
            saved: 'saved',
            error: 'error',
        },
        mimes: ['audio/mpeg', 'audio/mp3'],
        removable: false,
        deleting: false,
    }),

    computed: {
        ...mapGetters(['getSampleMp3Url', 'getActor', 'getActorFileUrl']),
    },

    methods: {
        ...mapActions(['uploadActorAudio', 'loadActorPortfolio', 'updateVoice']),

        showRemoveConfirm() {
            this.deleting = true;
        },

        hideRemoveConfirm() {
            this.deleting = false;
        },

        removeItem() {
            this.deleting = false;
            this.$emit('input', '');
        },

        async fileSelected(event: any) {
            try {
                const data = new FormData();
                data.append('hlas', this.hlasId);
                data.append('name', this.name);
                data.append('file', event.target.files[0]);

                const { filename } = await this.updateVoice(data);

                this.$emit('input', filename);
            } catch (error) {}

            // const types = ['audio/mpeg', 'audio/mp3'];
            //
            // const format = '.mp3';
            // const file = event.target.files[0];
            //
            // if (!(types.includes(file.type) && file.name.includes(format))) {
            //     alert('Vyberte MP3 súbor');
            //     return;
            // }
            //
            // if (this.uploading === true) return;
            //
            // this.uploading = true;
            // this.$refs.uploadBtn.setLoading();
            //
            // return this.uploadActorAudio({ file })
            //     .then((response: any) => {
            //         this.$refs.uploadBtn.setSuccess('Success', this.ms);
            //
            //         const record = new ActorPortfolioModel({
            //             file_type: 'audio',
            //             nazov: file.name.split('.')[0],
            //             file_id: response.data.uri,
            //             file_name: response.data.fileName,
            //             poradie: 0,
            //         });
            //
            //         this.getActor.addPortfolioItem(record);
            //
            //         this.submit();
            //     })
            //     .catch((err: any) => {
            //         this.$env.log.error(err);
            //         this.$bugsnag.notify(err);
            //         this.$refs.uploadBtn.setError('Failed', this.ms);
            //     })
            //     .finally(() => {
            //         this.uploading = false;
            //     });
        },

        submit() {
            if (this.saving == true) return;

            this.saving = true;
            this.state = 'saving';

            this.getActor
                .savePortfolio()
                .then((response: any) => {
                    this.saved = true;
                    this.state = 'saved';

                    this.loadActorPortfolio();
                })
                .catch((err: any) => {
                    this.$env.log.error(err);
                    this.$bugsnag.notify(err);
                })
                .finally(() => {
                    this.saving = false;
                    setTimeout(() => {
                        this.saved = false;
                        this.state = '';
                    }, this.ms);
                })
                .finally(() => {
                    this.saving = false;
                });
        },

        openFileSelect() {
            this.$refs.file.click();
        },
    },
};
